import * as React from 'react';
import type { SVGProps } from 'react';

const SvgCo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 1200" {...props}>
    <path d="M1027.2 273.6q-1.8-1.804 0 0l-852 1.2s-1.2 0-1.2 1.198l-21.601 646.8v1.2h1.199l632.4 4.8 266.4-7.199h1.2V920.4z" />
  </svg>
);
export default SvgCo;
